<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  created() {
    let admin_id = ''
    if (this.$route.query["admin_id"]) {
      admin_id = this.$route.query["admin_id"];
      localStorage.setItem('admin_id', this.$route.query["admin_id"])
    }
    if (localStorage.getItem('admin_id')) admin_id = localStorage.getItem('admin_id')

    this.getExpressList(admin_id);
  },
  methods: {
    ...mapActions(["getExpressList"]),
  }
};
</script>

<style>
body {
  background-color: rgb(255, 255, 255);
}
div {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container {
  position: relative;
  padding: 20px 30px;
}
.flex-center {
  display: flex;
  align-items: center;
}

.header {
  padding: 10px;
  color: rgb(0, 0, 0);
  background: linear-gradient(to right, #da3232, #ffffff);
  /* border: 1px solid rgb(110, 110, 110); */
  border-radius: 10px;
  font-size: 30px;
  font-weight: bold;
}
.express-list {
  justify-content: space-between;
  margin-top: 10px;
  background-color: #eeeeee;
  border-radius: 10px;
}
.item {
  padding: 10px 20px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/App.vue